const topValuesMixin = (superClass) => class extends superClass {
  top(n) {
    return this.values && this.values.slice(0, n);
  }
};

export default topValuesMixin;
